<div class="content">

  <div class="page-title">
    <h1>Equipment Management</h1>

    <div class="add" (click)="add()">
      <i class="fa fa-plus" aria-hidden="true"></i>
    </div>
  </div>

  <div class="card">
    <form class="card-title" (submit)="rebind()">
     <h3><i class="fa fa-search" aria-hidden="true"></i> Search Filters</h3>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Companies</label>
            <app-company-picker [accountId]="filter.companyId" [_placeholder]="'All'" (onCompanySet)="onCompanyChange($event)"></app-company-picker>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Locations</label>
            <app-location-picker [locationId]="filter.locationId" [companyId]="filter.companyId" [_placeholder]="'All'" (onLocationSet)="onLocationChange($event)"></app-location-picker>
          </div>
        </div>

        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label>Categories</label>
            <app-category-picker [categoryId]="filter.categoryId" [_placeholder]="'All'" (onCategorySet)="onCategoryChange($event)"></app-category-picker>

          </div>
        </div>
      </div>

      <div class="row buffer-bottom">

        <div class="col-md-3 col-sm-6">
          <label>Serial #</label>
          <input type="text" class="form-control" name="name" [(ngModel)]="filter.serial_Num" />
        </div>
        <div class="col-md-3 col-sm-6">
          <label>Plant #</label>
          <input type="text" class="form-control" name="acc" [(ngModel)]="filter.asset_Num" />
        </div>
        <!--<div class="col-md-3 col-sm-6">
          <label>Contract #</label>
          <input type="text" class="form-control" name="acc" [(ngModel)]="filter.contract_No" />
        </div>-->
      </div>

      <div class="row">
        <div class="col-md-12">
          <input type="submit" class="btn btn-primary" value="Refresh" />
          <button (click)="resetFilters()" value="Reset" class="btn reset-data">Reset</button>
          <!--<input type="button" value="Export" class="pull-right btn btn-primary" (click)="generateExcel()" />-->
        </div>
      </div>

    </form>
  </div>

 
  
    <app-loading-icon *ngIf="loading"></app-loading-icon>


  <ngx-datatable class="material" [rows]="rows" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
                 [rowHeight]="'auto'" [limit]="10" *ngIf="!loading">


    <ngx-datatable-column name="Company" prop="company_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Location" prop="location_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Contract " prop="location_Contract_No">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Category" prop="category_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Description" prop="description">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Serial #" prop="serial_Num">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Plant #" prop="asset_Num">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Edit">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span (click)="edit(row)" class="edit-option"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</span>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>
</div>
